import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const CreateModalHeader = () => {
  const {setItemIdForUpdate, itemIdForUpdate} = useListView()
  return (
    <div className='modal-header py-3'>
      {/* begin::Modal title */}
      <h2 className='fw-semibolder fs-4'>{itemIdForUpdate ? 'Edit' : 'Add'} Pre-Call Policy</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {CreateModalHeader}
